import { action, computed, observable } from 'mobx';
import { IEventAttributeDetailsDTO } from '../../../../../../../../api/attributes.dao';
import { IEventAttributeValue } from '../../../../../../../../api/events.dao';
import { ModuleAttributeVM } from './module-attribute/module-attribute.viewmodel';

export class ModuleAttributesVM {
    @observable
    private attributes: ModuleAttributeVM[] = [];

    constructor(private readonly eventAttributeOptions: IEventAttributeDetailsDTO[]) {}

    public static createFromDTO(dto: IEventAttributeValue[], eventAttributeOptions: IEventAttributeDetailsDTO[]): ModuleAttributesVM {
        const vm = new ModuleAttributesVM(eventAttributeOptions);
        dto.forEach(attrDTO => vm.addAttributeFromDTO(attrDTO));
        return vm;
    }

    @computed
    public get valid(): boolean {
        return this.attributes.every(a => a.valid);
    }

    public getAttributes(): ModuleAttributeVM[] {
        return this.attributes;
    }

    public getRemainingAttributeOptions(): IEventAttributeDetailsDTO[] {
        return this.eventAttributeOptions.filter(attr => attr.active && !this.isAlreadyAdded(attr.eventAttributeId));
    }

    @action
    public addAttributes(ids: number[]): void {
        ids
            .filter(id => !this.isAlreadyAdded(id))
            .forEach(id => this.addAttributeById(id));
    }

    @action
    public removeAttribute(attributeId: number): void {
        const idx = this.attributes.findIndex(a => a.getAttributeId() === attributeId);
        if (idx >= 0) this.attributes.splice(idx, 1);
    }

    public setTouched(): void {
        this.attributes.forEach(a => a.setTouched());
    }

    public toDTO(): IEventAttributeValue[] {
        return this.attributes.map(a => a.toDTO());
    }

    @action
    private addAttributeById(id: number): void {
        const attribute = this.findInCatalog(id);
        if (!attribute) return;
        this.attributes.push(ModuleAttributeVM.createNew(attribute));
        this.sortAttributesByName();
    }

    @action
    private addAttributeFromDTO(dto: IEventAttributeValue): void {
        const attribute = this.findInCatalog(dto.attributeId);
        if (!attribute) return;
        this.attributes.push(ModuleAttributeVM.createFromDTO(dto, attribute));
        this.sortAttributesByName();
    }

    private sortAttributesByName(): void {
        this.attributes = [...this.attributes].sort((a, b) => a.getAttributeName().localeCompare(b.getAttributeName()));
    }

    private findInCatalog(id: number): IEventAttributeDetailsDTO | undefined {
        return this.eventAttributeOptions.find(a => a.eventAttributeId === id);
    }

    private isAlreadyAdded(id: number): boolean {
        return this.attributes.some(a => a.getAttributeId() === id);
    }
}
